import React, { useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { INQUIRY_PROCESS_NAME, resolveLatestProcessName } from '../../transactions/transaction';

import { Heading, Modal } from '../../components';
import UserCard from './UserCard/UserCard';
import InquiryForm from './InquiryForm/InquiryForm';

import css from './ListingPage.module.css';
import BrandIconCard from '../../components/BrandIconCard/BrandIconCard';
import { parseDateFromISO8601 } from '../../util/dates';
import moment from 'moment';
import { hostLanguage } from '../../util/data';

const MAX_LENGTH = 300;
const SectionAuthorMaybe = props => {
  const {
    title,
    listing,
    authorDisplayName,
    onContactUser,
    isInquiryModalOpen,
    onCloseInquiryModal,
    sendInquiryError,
    sendInquiryInProgress,
    onSubmitInquiry,
    currentUser,
    onManageDisableScrolling,
    listingpage = false,
    isOpen = true,
    reviews,
  } = props;
  if (!listing.author) {
    return null;
  }

  const bio = listing?.author?.attributes?.profile?.bio || '';
  const transactionProcessAlias = listing?.attributes?.publicData?.transactionProcessAlias || '';
  const processName = resolveLatestProcessName(transactionProcessAlias.split('/')[0]);
  const isInquiryProcess = processName === INQUIRY_PROCESS_NAME;
  const totalReviews = reviews?.length || 0;
  const totalRating =
    reviews?.reduce((sum, review) => {
      const rating = review?.attributes?.rating;
      return sum + (typeof rating === 'number' ? rating : 0);
    }, 0) || 0;

  const averageRating = totalReviews > 0 ? (totalRating / totalReviews).toFixed(1) : '0';

  const { host_language, location } = listing.author?.attributes?.profile?.publicData || [];
  const { address } = location?.selectedPlace || {};
  const languages = host_language
    ?.map(langKey => {
      const match = hostLanguage.find(lang => lang.key === langKey);
      return match ? match.label : null;
    })
    .filter(Boolean)
    .join(', ');

  const { createdAt } = currentUser?.attributes || {};
  const createdDate = parseDateFromISO8601(createdAt);
  const now = new Date();
  const years = moment(now).diff(createdDate, 'years');
  const days = moment(now).diff(createdDate, 'days');
  const value = years >= 1 ? years : days;
  const label = years >= 1 ? 'Year Hosting' : 'Days Hosting';

  const [isModalOpen, setModalOpen] = useState(false);

  const isLong = bio.length > MAX_LENGTH;
  const shortBio = isLong ? bio?.slice(0, MAX_LENGTH) + '' : bio;

  return (
    <section id="author" className={css.sectionAuthor}>
      <Heading as="h2" rootClassName={css.hostHeading}>
        <FormattedMessage id="ListingPage.aboutProviderTitle" />
      </Heading>
      <div className={css.sectionAuthorContent}>
        <div className={css.userCardContent}>
          <UserCard
            user={listing.author}
            currentUser={currentUser}
            onContactUser={onContactUser}
            showContact={!isInquiryProcess}
            listingpage={listingpage}
            listing={listing}
          />
          {listingpage ? (
            <div className={css.authorDetails}>
              <div className={css.reviewHeading}>
                <div className={css.totalReviews}>{totalReviews}</div>
                <div className={css.reviewTitle}>Reviews</div>
              </div>

              <span className={css.verticalBar} />

              <div className={css.reviewHeading}>
                <div className={css.totalReviews}>
                  {averageRating.length ? averageRating : '0.0'} <span>★</span>
                </div>
                <div className={css.reviewTitle}>Rating</div>
              </div>

              <span className={css.verticalBar} />

              <div className={css.ratingAvarage}>
                <div className={css.totalReviews}>{value}</div>
                <div className={css.reviewTitle}>{label}</div>
              </div>
            </div>
          ) : null}
        </div>
        <div className={css.hostDetails}>
          <div className={css.detailHeading}>Host Details</div>
          <div className={css.hostDescription}>
            <p>
              {shortBio}
              {isLong && (
                <span className={css.readMore} onClick={() => setModalOpen(true)}>
                  Read More...
                </span>
              )}
            </p>

            {isModalOpen && (
              <Modal
                className={css.hostModalWrapper}
                isOpen={isOpen}
                onClose={() => setModalOpen(false)}
                onManageDisableScrolling={onManageDisableScrolling}
                // title="About the Host"
              >
                <h2 className={css.detailHeading}>About the Host</h2>
                <p>{bio}</p>
              </Modal>
            )}
          </div>
          {/* <div className={css.detailDescription}>
            <div>Response rate: 100%</div>
            <div>Responds within an hour</div>
          </div> */}
          {/* <button className={css.messageHostButton}>Message host</button> */}
          <div className={css.bottomContent}>
            <div className={css.leftSide}>
              {languages?.length > 0 ? (
                <div className={css.leftSideItem}>
                  <BrandIconCard type="language" />
                  {languages}
                </div>
              ) : null}

              {address?.length > 0 ? (
                <div className={css.leftSideItem}>
                  <BrandIconCard type="location" />
                  {address}
                </div>
              ) : null}
            </div>
            <div className={css.rightSide}>
              To help protect your payment, always use fijianhost.com to make payments and
              communicate with hosts.
            </div>
          </div>
        </div>
      </div>

      <div className={css.inquiryForm}>
        <Modal
          id="ListingPage.inquiry"
          contentClassName={css.inquiryModalContent}
          isOpen={isInquiryModalOpen}
          onClose={onCloseInquiryModal}
          usePortal
          className={css.inquiryFormModal}
          onManageDisableScrolling={onManageDisableScrolling}
        >
          <InquiryForm
            className={css.inquiryForm}
            submitButtonWrapperClassName={css.inquirySubmitButtonWrapper}
            listingTitle={title}
            authorDisplayName={authorDisplayName}
            sendInquiryError={sendInquiryError}
            onSubmit={onSubmitInquiry}
            inProgress={sendInquiryInProgress}
          />
        </Modal>
      </div>
    </section>
  );
};

export default SectionAuthorMaybe;
